module.exports = __webpack_public_path__ + "img/17.83f54d1c.png";